import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export interface FeaturesConfig {
  templates: boolean;
  connectors: boolean;
  settingsWorkspace: boolean;
  settingsNotifications: boolean;
  settingsIntegration: boolean;
  createWorkspace: boolean;
  mediaLibrary: boolean;
  mediaLibraryProviders: string[];
}

export interface PlanFeaturesConfig {
  models: string[];
  visibility: string[];
  customDomain: boolean;
}

export interface AllPlanFeaturesConfig {
  free: PlanFeaturesConfig;
  standard: PlanFeaturesConfig;
  pro: PlanFeaturesConfig;
  enterprise?: PlanFeaturesConfig;
  embed?: PlanFeaturesConfig;
}

export interface NetworkConfig {
  egressIps: string[]; // Static IPs for database whitelist
}

export const featuresApi = {
  /**
   * Get public feature flags
   * No authentication required
   */
  async getFeatures(): Promise<FeaturesConfig> {
    const response = await axios.get(`${API_URL}/api/public/features`);
    return response.data;
  },

  /**
   * Get plan-based feature restrictions
   * No authentication required - used for paywall UI
   */
  async getPlanFeatures(): Promise<AllPlanFeaturesConfig> {
    const response = await axios.get(`${API_URL}/api/public/plan-features`);
    return response.data;
  },

  /**
   * Get network configuration (egress IPs for database whitelist)
   * No authentication required - used by connectors UI
   */
  async getNetworkConfig(): Promise<NetworkConfig> {
    const response = await axios.get(`${API_URL}/api/public/network`);
    return response.data;
  },
};
